module.exports = __webpack_public_path__ + "static/media/BANNER - installment payment_V6.76369791.jpg";